// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getStockReducer } from './getStock';
import { reducer as getListStockReducer } from './getListStock';
import { reducer as getListStockClearReducer } from './getListStockClear';
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as reportStockReducer } from './reportStock';
import { reducer as stocksProductoReducer } from './stocksProducto';
import { reducer as deleteStockReducer } from './deleteStock';
import { reducer as getFotoMiniaturaReducer } from './getFotoMiniatura';
import { reducer as loadSchemasFromStockReducer } from './loadSchemasFromStock';
import { reducer as cancelMassiveUploadReducer } from './cancelMassiveUpload';
import { reducer as setMassiveUploadFileReducer } from './setMassiveUploadFile';
import { reducer as uploadMassiveStockReducer } from './uploadMassiveStock';
import { reducer as downloadStockTemplateReducer } from './downloadStockTemplate';
import { reducer as saveValidateDataStepReducer } from './saveValidateDataStep';
import { reducer as selectTranslationReducer } from './selectTranslation';
import { reducer as confirmCartLotReducer } from './confirmCarLot';
import { reducer as cancelCarLotModalReducer } from './cancelCarLotModal';
import { reducer as validateInconsistencies } from './validateInconsistencies';
import { reducer as setMassiveUploadDropzoneStatusReducer } from './setMassiveUploadDropzoneStatus';
import { reducer as goBackStepReducer } from './goBackStep';
import { reducer as processData } from './processData';
import { reducer as confirmImportReducer } from './confirmImport';
import { reducer as downloadSummaryReducer } from './downloadSummary';
import { reducer as deleteDictionaryTranslationReducer } from './deleteDictionaryTranslation/reducer';
import { reducer as editDictionaryTranslationReducer } from './editDictionaryTranslation/reducer';
import { reducer as getDictionaryOptionsReducer } from './getDictionaryOptions/reducer';
import { reducer as getDictionaryAttributesReducer } from './getDictionaryAttributes';
import { reducer as getDictionaryCarlots } from './getDictionaryCarlots/reducer';
import { reducer as getReportReducer } from './getReport';
import { reducer as clearReportReducer } from './clearReport';
import { reducer as takingCarManagementFieldsReducer } from './takingCarManagementFields';
import { reducer as getCarLotOptionsReducer } from './getCarLotOptions/reducer';
import { reducer as saveTakingCarManagment } from './saveTakingCarManagment/reducer';
import { reducer as getStateMachineReducer } from './getStateMachine/reducer';
import { reducer as dispatchActionReducer } from './dispatchAction/reducer';
import { reducer as repeatTakingCarRequestReducer } from './repeatTakingCarRequest/reducer'
import { reducer as getTakingCarDetailsReducer } from './getTakingCarDetails/reducer'
import { reducer as loadTakingCarPaginatedReducer} from './loadTakingCarPaginated/reducer'
import { reducer as clearCurrentTakingCarReducer } from './clearCurrentTakingCar/reducer'
import { reducer as clearFastStockLoadingReducer } from './clearFastStockLoading/reducer'
import { reducer as getImagesExpertiseReducer } from './getImagesExpertise/reducer'
import { reducer as selectImageExpertiseReducer } from './selectImageExpertise/reducer'
import { reducer as getBrandsDataMasterReducer } from './getBrandsDataMaster/reducer'
import { reducer as getModelsDataMasterReducer } from './getModelsDataMaster/reducer'
import { reducer as getVersionsDataMasterReducer } from './getVersionsDataMaster/reducer'
import { reducer as getYearsDataMasterReducer } from './getYearsDataMaster/reducer'
import { reducer as getCarDetailDataMasterReducer } from './getCarDetailDataMaster/reducer'
import { reducer as getCarLotsDataMasterReducer } from './getCarLotsDataMaster/reducer'
import { reducer as getBranchOfficesDataMasterReducer } from './getBranchOfficesDataMaster/reducer'
import { reducer as getLocationsDataMasterReducer } from './getLocationsDataMaster/reducer'
import { reducer as getExchangeRatesDataMasterReducer } from './getExchangeRatesDataMaster/reducer'
import { reducer as getReferencePricesReducer } from './getReferencePrices/reducer'
import { reducer as deleteImageFromGaleryReducer } from './deleteImageFromGalery/reducer'
import { reducer as getSalesTypeCatalogs } from './getSalesTypeCatalogs/reducer'
import { reducer as saveFastStockLoadingDataReducer } from './saveFastStockLoadingData/reducer'
import { reducer as updateFastStockLoadingData } from './updateFastStockLoadingData';
import { reducer as setMainFilterDataReducer } from './setMainFilterData';
import { reducer as savePathToCancelFastStockLoadingReducer } from './PathToCancelFastStockLoading/reducer';
import { reducer as deleteTakingCarManagementReducer} from './deleteTakingCarManagement/reducer'
import { reducer as updateExistingFastStockLoadingDataReducer} from './updateExistingFastStockLoadingData/reducer'

const reducers = [
  getStockReducer,
  getListStockReducer,
  getListStockClearReducer,
  reportStockReducer,
  stocksProductoReducer,
  deleteStockReducer,
  getFotoMiniaturaReducer,
  loadSchemasFromStockReducer,
  cancelMassiveUploadReducer,
  setMassiveUploadFileReducer,
  uploadMassiveStockReducer,
  downloadStockTemplateReducer,
  saveValidateDataStepReducer,
  selectTranslationReducer,
  confirmCartLotReducer,
  cancelCarLotModalReducer,
  validateInconsistencies,
  setMassiveUploadDropzoneStatusReducer,
  goBackStepReducer,
  processData,
  confirmImportReducer,
  downloadSummaryReducer,
  deleteDictionaryTranslationReducer,
  editDictionaryTranslationReducer,
  getDictionaryOptionsReducer,
  getDictionaryAttributesReducer,
  getDictionaryCarlots,
  getReportReducer,
  clearReportReducer,
  takingCarManagementFieldsReducer,
  getCarLotOptionsReducer,
  saveTakingCarManagment,
  getStateMachineReducer,
  dispatchActionReducer,
  getTakingCarDetailsReducer,
  clearCurrentTakingCarReducer,
  clearFastStockLoadingReducer,
  repeatTakingCarRequestReducer,
  getImagesExpertiseReducer,
  selectImageExpertiseReducer,
  getBrandsDataMasterReducer,
  getModelsDataMasterReducer,
  getYearsDataMasterReducer,
  getVersionsDataMasterReducer,
  getCarDetailDataMasterReducer,
  repeatTakingCarRequestReducer,
  getCarLotsDataMasterReducer,
  getBranchOfficesDataMasterReducer,
  getLocationsDataMasterReducer,
  getExchangeRatesDataMasterReducer,
  getReferencePricesReducer,
  deleteImageFromGaleryReducer,
  saveFastStockLoadingDataReducer,
  updateFastStockLoadingData,
  setMainFilterDataReducer,
  getSalesTypeCatalogs,
  savePathToCancelFastStockLoadingReducer,
  deleteTakingCarManagementReducer,
  loadTakingCarPaginatedReducer,
  updateExistingFastStockLoadingDataReducer
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
